export default __webpack_public_path__ + "static/media/noMark.c463bf68.svg";